'use client';

import { c as _c } from "react/compiler-runtime";
import { useLenis } from 'lenis/react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { forwardRef, useEffect, useState } from 'react';
import { Icon } from '@/components/icon';
import { Sheet, SheetContent, SheetDescription, SheetTitle, SheetTrigger } from '@/components/ui/sheet';
const navigationLinks = [{
  label: 'Home',
  href: '/'
}, {
  label: 'Watch Now',
  href: '/browse'
}, {
  label: 'About',
  href: '/about'
}, {
  label: 'Sources',
  href: '/sources'
}, {
  label: 'Events',
  href: '/events'
}, {
  label: 'Pay it Forward',
  href: '/pay-it-forward'
}, {
  label: 'Merch',
  href: 'https://shop.christspiracy.com/',
  external: true
}];
const socialLinks = [{
  label: 'Instagram',
  href: 'https://www.instagram.com/christspiracy/'
}, {
  label: 'Facebook',
  href: 'https://www.facebook.com/christspiracy/'
}, {
  label: 'YouTube',
  href: 'https://www.youtube.com/@christspiracyfilm'
}, {
  label: 'Community',
  href: 'https://community.christspiracy.com/oauth2/callback'
}];
interface MenuProps {
  onOpenChange?: (open: boolean) => void;
}
export function Menu(t0) {
  const $ = _c(34);
  const {
    onOpenChange
  } = t0;
  const [open, setOpen] = useState(false);
  const lenis = useLenis();
  const pathname = usePathname();
  let t1;
  if ($[0] !== onOpenChange) {
    t1 = newOpen => {
      setOpen(newOpen);
      onOpenChange?.(newOpen);
    };
    $[0] = onOpenChange;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleOpenChange = t1;
  let t2;
  if ($[2] !== handleOpenChange) {
    t2 = () => {
      handleOpenChange(false);
    };
    $[2] = handleOpenChange;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== pathname) {
    t3 = [pathname];
    $[4] = pathname;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  useEffect(t2, t3);
  let t4;
  let t5;
  if ($[6] !== lenis || $[7] !== open) {
    t4 = () => {
      if (!lenis) {
        return;
      }
      if (open) {
        lenis.stop();
      } else {
        lenis.start();
      }
      return () => {
        lenis.start();
      };
    };
    t5 = [open, lenis];
    $[6] = lenis;
    $[7] = open;
    $[8] = t4;
    $[9] = t5;
  } else {
    t4 = $[8];
    t5 = $[9];
  }
  useEffect(t4, t5);
  let t6;
  if ($[10] !== open) {
    t6 = open && <div className="fade-in-0 fixed inset-0 z-50 animate-in bg-black/50 blur-md duration-300" />;
    $[10] = open;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== open) {
    t7 = <SheetTrigger asChild={true}><MenuButton isOpen={open} /></SheetTrigger>;
    $[12] = open;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  let t9;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <SheetTitle className="sr-only">Navigation Menu</SheetTitle>;
    t9 = <SheetDescription className="sr-only">Main navigation and social links</SheetDescription>;
    $[14] = t8;
    $[15] = t9;
  } else {
    t8 = $[14];
    t9 = $[15];
  }
  let t10;
  if ($[16] !== handleOpenChange) {
    t10 = () => handleOpenChange(false);
    $[16] = handleOpenChange;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  let t12;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <span className="relative block h-[9px] w-8"><span className="absolute top-1/2 block h-px w-8 -translate-y-1/2 rotate-45 bg-white transition-transform duration-300" /><span className="absolute top-1/2 block h-px w-8 -translate-y-1/2 -rotate-45 bg-white transition-transform duration-300" /></span>;
    t12 = <span className="relative top-px leading-none">Close</span>;
    $[18] = t11;
    $[19] = t12;
  } else {
    t11 = $[18];
    t12 = $[19];
  }
  let t13;
  if ($[20] !== t10) {
    t13 = <button type="button" onClick={t10} className="absolute top-6 left-6 flex items-center gap-2 font-medium text-xs uppercase tracking-0.02 md:top-10 md:left-10" aria-label="Close menu">{t11}{t12}</button>;
    $[20] = t10;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  let t15;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <div><MenuContent /></div>;
    t15 = <MenuFooter />;
    $[22] = t14;
    $[23] = t15;
  } else {
    t14 = $[22];
    t15 = $[23];
  }
  let t16;
  if ($[24] !== t13) {
    t16 = <SheetContent side="left" className="scrollbar-none flex h-full min-h-svh w-full max-w-[480px] flex-col justify-between overflow-auto border-none bg-black p-4 text-christ-white-900 uppercase md:max-w-[640px] md:p-8 [&>button.absolute.top-4.right-4]:hidden">{t8}{t9}{t13}{t14}{t15}</SheetContent>;
    $[24] = t13;
    $[25] = t16;
  } else {
    t16 = $[25];
  }
  let t17;
  if ($[26] !== handleOpenChange || $[27] !== open || $[28] !== t16 || $[29] !== t7) {
    t17 = <Sheet open={open} onOpenChange={handleOpenChange}>{t7}{t16}</Sheet>;
    $[26] = handleOpenChange;
    $[27] = open;
    $[28] = t16;
    $[29] = t7;
    $[30] = t17;
  } else {
    t17 = $[30];
  }
  let t18;
  if ($[31] !== t17 || $[32] !== t6) {
    t18 = <>{t6}{t17}</>;
    $[31] = t17;
    $[32] = t6;
    $[33] = t18;
  } else {
    t18 = $[33];
  }
  return t18;
}
interface MenuButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  isOpen: boolean;
}
const MenuButton = forwardRef<HTMLButtonElement, MenuButtonProps>((t0, ref) => {
  const $ = _c(20);
  let className;
  let isOpen;
  let props;
  if ($[0] !== t0) {
    ({
      isOpen,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = isOpen;
    $[3] = props;
  } else {
    className = $[1];
    isOpen = $[2];
    props = $[3];
  }
  const t1 = `flex items-center gap-2 font-medium text-sm uppercase tracking-0.02 shadow-lg md:text-base ${className || ""}`;
  const t2 = isOpen ? "Close menu" : "Open menu";
  const t3 = `absolute block h-px w-6 bg-white shadow-md transition-transform duration-300 md:w-8 ${isOpen ? "top-1/2 -translate-y-1/2 rotate-45" : "top-0"}`;
  let t4;
  if ($[4] !== t3) {
    t4 = <span className={t3} />;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = `absolute block h-px w-6 bg-white shadow-md transition-transform duration-300 md:w-8 ${isOpen ? "top-1/2 -translate-y-1/2 -rotate-45" : "bottom-0"}`;
  let t6;
  if ($[6] !== t5) {
    t6 = <span className={t5} />;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t4 || $[9] !== t6) {
    t7 = <span className="relative block h-[7px] w-6 md:h-[9px] md:w-8">{t4}{t6}</span>;
    $[8] = t4;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  const t8 = isOpen ? "Close" : "Menu";
  let t9;
  if ($[11] !== t8) {
    t9 = <span className="relative top-px hidden leading-none drop-shadow-md sm:inline">{t8}</span>;
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== props || $[14] !== ref || $[15] !== t1 || $[16] !== t2 || $[17] !== t7 || $[18] !== t9) {
    t10 = <button ref={ref} className={t1} aria-label={t2} {...props}>{t7}{t9}</button>;
    $[13] = props;
    $[14] = ref;
    $[15] = t1;
    $[16] = t2;
    $[17] = t7;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  return t10;
});
MenuButton.displayName = 'MenuButton';
function MenuContent() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="mt-24 font-bold text-[2rem] leading-tight md:mt-32 md:text-[2.5rem]"><ul className="space-y-5">{navigationLinks.map(_temp)}</ul></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
function _temp(link) {
  return "external" in link && link.external ? <li key={link.href}><a className="flex gap-2 hover:opacity-75" href={link.href} target="_blank" rel="noopener noreferrer"><span>{link.label}</span><Icon name="arrow" className="max-w-[1.2rem] rotate-135" /></a></li> : <li key={link.href}><Link href={link.href} className="hover:opacity-75">{link.label}</Link></li>;
}
function MenuFooter() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="mt-8 text-sm tracking-wide"><ul className="flex flex-wrap gap-4">{socialLinks.map(_temp2)}</ul></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
function _temp2(link) {
  return <li key={link.href}><a href={link.href} target="_blank" rel="noopener noreferrer" className="hover:underline">{link.label}</a></li>;
}